import React, { useRef } from 'react';
import styled from 'styled-components';
import imageCompression from 'browser-image-compression';

type FileFieldComponentProps = {
  id?: string
  className?: string
  placeholder?: string
  mb?: string
  setFile: React.Dispatch<React.SetStateAction<{ id: number, url: string }>>
  required?: boolean
  autoFocus?: boolean
}

const FileFieldStyle = styled.div<{$mb?: string}>`
  margin-bottom: ${props => props.$mb || '0'};
  width: 100%; 
  height: 50px;
  
  button {
    background: #393432;
    border: none;
    border-radius: 25px;
    color: white;
    cursor: pointer;
    font-size: 12px;
    width: 100%;
    height: 100%;
    
    &:hover {
      background: #696767;
    }
  }
  
  input {
    display: none;
  }
`;

const FileField: React.FC<FileFieldComponentProps> = ({ id, className, placeholder, mb, required, autoFocus, setFile }) => {
  const reader = new FileReader();
  const inputRef = useRef<HTMLInputElement>(null);
  const onClickButton = () => inputRef.current?.click();
  const compressImage = async (
    file: File,
    options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 600,
    }
  ): Promise<File> => {
    try {
      return await imageCompression(file, options);
    } catch (err) {
      return Promise.reject(new Error(`compress failed: ${err}`));
    }
  };
  const onChangeInput = async () => {
    reader.addEventListener('load', () => {
      setFile({ id: null, url: reader.result.toString() });
    });
    const compressedImage = await compressImage(inputRef.current.files[0]);
    if (inputRef.current.files.length) reader.readAsDataURL(compressedImage);
  };

  return (
    <FileFieldStyle className={className} $mb={mb}>
      <button type='button' onClick={onClickButton}>{ placeholder }</button>
      <input type='file' id={id} ref={inputRef} required={required} autoFocus={autoFocus} onChange={onChangeInput} />
    </FileFieldStyle>
  );
};

export default FileField;
